import React from 'react';
const defaultOverlayContext = {
  publicUrl: 'http://localhost:3101'
};
const OverlayContext = /*#__PURE__*/React.createContext(defaultOverlayContext);
export { OverlayContext, defaultOverlayContext };